import SourcesListPanel from "../Sources/SourcesListPanel";
import { Text, Box, Flex } from "@chakra-ui/react";
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { getFolderForRound, KB_FOLDER } from "api/common/fileinfo";
import { useQuery } from "react-query";
import fileinfoService from "api/common/fileinfo.service";
import SourcesTipsSideBar from "./SourcesTipsSideBar";
import { useAuth } from "context";
import questionnaireService from "../../../api/issb/questionnaire.service";
import { issbKeys } from "hooks/query";

/** must pick/confirm sources before proceeding */
export default function AIReviewSourcesPanel({ setNextDisabled, sourceIds, setSourceIds, hideTips, sourceRoundIds, setSourceRoundIds }) {
  const roundSelector = useSelector((state) => state.issbRound);
  const { getAccessTokenSilently } = useAuth();
  const { data: filesPage } = useQuery(["fileinfoService.list", "all"], async () => {
    await getAccessTokenSilently();
    return fileinfoService.list();
  });
  // HACK: add KB to the list of files
  const { data: filesKBPage } = useQuery(["fileinfoService.list", KB_FOLDER], async () => {
    await getAccessTokenSilently();
    return fileinfoService.list({ query: "folder:" + KB_FOLDER });
  });

  const questionnaireId = roundSelector?.selectedRound?.id;

  // Fetch questionnaire to get sourceRoundIds
  // HACK: query key is reset by SourcesListPanel
  const {data: questionnaireData} = useQuery(issbKeys.questionnaireRound(questionnaireId), async () => {
    await getAccessTokenSilently();
    return questionnaireService.get(questionnaireId);
  }, {
    enabled: !!questionnaireId
  });

  // Note: useCallback to avoid triggering useEffect on every render
  const selectAllFilesInRound = useCallback(() => {
    const roundId = roundSelector?.selectedRound?.id;
    const folder = getFolderForRound(roundId);
    let filesInRound = filesPage?.content?.filter((f) => f.folders?.includes(folder));
    console.log("selecting all files in round", roundId, "folder", folder, "filesInRound", filesInRound);
    setSourceIds(filesInRound?.map((f) => f.id));
  }, [filesPage?.content, roundSelector?.selectedRound?.id, setSourceIds]);

  // select all files in round once we have the files
  useEffect(() => {
    if (filesPage?.content) selectAllFilesInRound();
  }, [filesPage?.content, selectAllFilesInRound]);

  // add in KB files
  useEffect(() => {
    if (!filesKBPage?.content || !filesPage?.content) return;
    let kbIds = filesKBPage.content.map((f) => f.id);
    // remove any active files that are also KB files
    kbIds = kbIds.filter((id) => !sourceIds.includes(id));
    // add the KB files to the list of files
    if (kbIds.length > 0) {
      setSourceIds((prev) => [...(prev || []), ...kbIds]);
    }
  }, [filesKBPage?.content, filesPage?.content, sourceIds, setSourceIds]);

  // you must select at least one file
  useEffect(() => {
    setNextDisabled(sourceIds?.length === 0 && ! sourceRoundIds?.length > 0);
  }, [sourceIds, setNextDisabled, sourceRoundIds]);

  return (
    <Box>
      <Text mb={4}>
        Select the files you want ESG360 AI to use when drafting answers. Deselecting a source will not remove it. It
        will just be ignored in this review.
      </Text>

      <Flex gap={4} flexDirection="row">
        <Box flexGrow={1}>
          <SourcesListPanel
            hideColumns={["usage", "aiDate", "actions"]}
            hideAIReviewButton={true}
            selectedIds={sourceIds}
            setSelectedIds={setSourceIds}
			sourceRoundIds={sourceRoundIds}
			setSourceRoundIds={setSourceRoundIds}
          />
        </Box>

        {!hideTips && <SourcesTipsSideBar />}
      </Flex>
    </Box>
  );
}
